<template>
    <div class="knd-colofon">
        
        <div class="knd-paragraaf__tekst knd-wrapper knd-m-auto knd-my-5">
            <div class="" v-html="content.tekst"></div>
        </div>
        <canvas class="knd-canvas" ref="canvas"></canvas>
    </div>
</template>

<script>
    import Bubbles from './header/bubbles';

    export default {
        props: {
            content: {
                type: Object
            }
        },

        mounted () {
            let bubbles = new Bubbles(this.$refs.canvas);
        },
    }
</script>

<style lang="scss" scoped>

    .knd-canvas {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }

.knd-colofon {
   background: #4E243F;
   color: #FFF;
   width: 100%;
   min-height: 50vh;
   position: relative;
   overflow:hidden;
}

.knd-paragraaf__tekst {
    position: relative;
    text-align: center;
}

</style>